var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _mask, _path8, _mask2, _path9, _mask3, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _mask4, _path34, _path35, _path36, _path37, _path38, _path39, _mask5, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g, _rect2, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _g2, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _g3, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruckRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 439,
    height: 194,
    viewBox: "0 0 439 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 393.485,
    height: 14.7097,
    rx: 3,
    transform: "matrix(-1 0 0 1 408.193 178.968)",
    fill: "#EFECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M334.523 120.668L51.0178 120.668V126.54L103.421 132.461H177.595L340.627 126.883L342.037 120.668H334.523Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0174 129.605L351.745 129.605V147.539L51.0174 147.539V129.605Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3853 134.483H62.4795V156.29H58.3853V134.483Z",
    fill: "url(#paint0_linear_2221_3109)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5099 143.211H58.373V154.17H56.5099V143.211Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M322.045 145.835H333.347V154.158H322.045V145.835Z",
    fill: "#222B2E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M222.423 138.529H232.757V162.26H222.423V138.529Z",
    fill: "#151E21"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M210.68 138.53H221.025V162.261H210.68V138.53Z",
    fill: "#151E21"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_2221_3109",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.799 137.842H291.168C293.929 137.842 296.168 140.081 296.168 142.842V162.728C296.168 165.489 293.929 167.728 291.168 167.728H212.799C210.038 167.728 207.799 165.489 207.799 162.728V142.842C207.799 140.081 210.038 137.842 212.799 137.842Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M212.799 137.842H291.168C293.929 137.842 296.168 140.081 296.168 142.842V162.728C296.168 165.489 293.929 167.728 291.168 167.728H212.799C210.038 167.728 207.799 165.489 207.799 162.728V142.842C207.799 140.081 210.038 137.842 212.799 137.842Z",
    fill: "#222222",
    stroke: "url(#paint1_linear_2221_3109)",
    strokeWidth: 2,
    mask: "url(#path-9-inside-1_2221_3109)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-2_2221_3109",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.144 154.158H333.333C333.333 154.158 335.331 132.694 342.318 124.481C349.305 116.256 372.62 116.722 379.117 118.205C385.614 119.676 396.131 154.17 396.131 154.17L396.144 154.158Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M396.144 154.158H333.333C333.333 154.158 335.331 132.694 342.318 124.481C349.305 116.256 372.62 116.722 379.117 118.205C385.614 119.676 396.131 154.17 396.131 154.17L396.144 154.158Z",
    fill: "#222222",
    stroke: "url(#paint2_linear_2221_3109)",
    strokeWidth: 2,
    mask: "url(#path-10-inside-2_2221_3109)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-3_2221_3109",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.338 147.98C329.939 140.956 331.03 135.587 331.03 135.587L332.819 134.974L335.038 128.82L336.619 126.602H334.781V124.064H331.814L334.425 118.867V97.0719H337.33L337.882 74.517C337.882 74.517 339.12 51.4228 339.255 46.0047C339.39 40.5866 340.91 32.1898 341.731 30.535C342.552 28.8801 345.445 28.1447 353.67 28.4634C361.883 28.7821 382.832 29.9343 389.525 30.486C396.23 31.0376 407.753 32.0427 412.166 33.146C416.579 34.2492 418.295 35.9653 418.295 35.9653C418.295 35.9653 423.137 36.4924 424.927 39.2505C426.716 42.0086 428.653 49.2653 428.653 49.2653L426.214 49.7679L422.904 47.3408C422.904 47.3408 425.883 56.4854 427.77 64.9802C429.646 73.4751 431.485 86.0151 431.485 86.0151L433.041 88.5893C433.041 88.5893 433.777 89.2757 433.777 89.9622C433.777 90.6486 433.225 91.6661 433.225 91.6661L434.145 103.422H434.831L435.015 106.413H434.329L434.378 108.251H434.022L433.948 109.354C433.948 109.354 434.537 112.015 434.807 115.827C435.076 119.639 435.076 123.415 435.076 123.415L434.5 125.106L434.77 128.955L432.612 129.188V133.846L434.341 136.506C434.341 136.506 434.647 138.431 434.537 142.868C434.427 147.293 434.427 156.855 434.427 156.855C434.427 156.855 436.045 153.851 436.314 152.92C436.584 152 437.234 150.762 438.361 150.922C439.489 151.081 438.974 153.545 437.969 155.849C436.964 158.166 436.351 159.735 433.495 160.005C430.639 160.275 422.536 160.324 422.536 160.324H398.29L398.008 158.031H392.957L392.087 153.214C392.087 153.214 389.194 141.691 385.835 135.121C382.489 128.551 377.659 121.993 367.975 121.845C367.975 121.845 354.982 121.845 352.592 121.845C350.201 121.845 346.205 123.586 344.881 124.236C344.881 124.236 340.652 132.964 339.549 135.354C338.446 137.744 336.337 145.455 335.418 151.792C334.499 158.129 334.499 165.791 334.499 165.791H328.529C328.529 165.791 328.713 155.04 329.313 148.017L329.338 147.98Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M329.338 147.98C329.939 140.956 331.03 135.587 331.03 135.587L332.819 134.974L335.038 128.82L336.619 126.602H334.781V124.064H331.814L334.425 118.867V97.0719H337.33L337.882 74.517C337.882 74.517 339.12 51.4228 339.255 46.0047C339.39 40.5866 340.91 32.1898 341.731 30.535C342.552 28.8801 345.445 28.1447 353.67 28.4634C361.883 28.7821 382.832 29.9343 389.525 30.486C396.23 31.0376 407.753 32.0427 412.166 33.146C416.579 34.2492 418.295 35.9653 418.295 35.9653C418.295 35.9653 423.137 36.4924 424.927 39.2505C426.716 42.0086 428.653 49.2653 428.653 49.2653L426.214 49.7679L422.904 47.3408C422.904 47.3408 425.883 56.4854 427.77 64.9802C429.646 73.4751 431.485 86.0151 431.485 86.0151L433.041 88.5893C433.041 88.5893 433.777 89.2757 433.777 89.9622C433.777 90.6486 433.225 91.6661 433.225 91.6661L434.145 103.422H434.831L435.015 106.413H434.329L434.378 108.251H434.022L433.948 109.354C433.948 109.354 434.537 112.015 434.807 115.827C435.076 119.639 435.076 123.415 435.076 123.415L434.5 125.106L434.77 128.955L432.612 129.188V133.846L434.341 136.506C434.341 136.506 434.647 138.431 434.537 142.868C434.427 147.293 434.427 156.855 434.427 156.855C434.427 156.855 436.045 153.851 436.314 152.92C436.584 152 437.234 150.762 438.361 150.922C439.489 151.081 438.974 153.545 437.969 155.849C436.964 158.166 436.351 159.735 433.495 160.005C430.639 160.275 422.536 160.324 422.536 160.324H398.29L398.008 158.031H392.957L392.087 153.214C392.087 153.214 389.194 141.691 385.835 135.121C382.489 128.551 377.659 121.993 367.975 121.845C367.975 121.845 354.982 121.845 352.592 121.845C350.201 121.845 346.205 123.586 344.881 124.236C344.881 124.236 340.652 132.964 339.549 135.354C338.446 137.744 336.337 145.455 335.418 151.792C334.499 158.129 334.499 165.791 334.499 165.791H328.529C328.529 165.791 328.713 155.04 329.313 148.017L329.338 147.98Z",
    fill: "#D0E1EE",
    stroke: "#222222",
    strokeWidth: 2,
    mask: "url(#path-11-inside-3_2221_3109)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.07
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M331.029 135.587H339.45C338.322 138.247 336.324 145.639 335.442 151.755C334.522 158.093 334.522 165.754 334.522 165.754H328.553C328.553 165.754 328.737 155.004 329.337 147.98C329.938 140.956 331.029 135.587 331.029 135.587Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.07
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M331.029 135.587H339.45C338.322 138.247 336.324 145.639 335.442 151.755C334.522 158.093 334.522 165.754 334.522 165.754H328.553C328.553 165.754 328.737 155.004 329.337 147.98C329.938 140.956 331.029 135.587 331.029 135.587Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M339.267 135.17C340.284 132.976 343.974 125.339 344.525 124.199L339.487 124.236L339.573 124.064H331.814L332.157 123.377H345.702L345.763 123.451C347.382 122.74 350.52 121.49 352.616 121.49H368C378.076 121.637 383.004 128.759 386.154 134.937C389.488 141.458 392.393 152.981 392.418 153.103L393.251 157.676L393.288 158.007H392.969L392.099 153.189C392.099 153.189 389.206 141.667 385.847 135.096C382.501 128.526 377.671 121.968 367.987 121.821C367.987 121.821 354.994 121.821 352.603 121.821C350.213 121.821 346.217 123.561 344.893 124.211C344.893 124.211 340.664 132.939 339.561 135.329C338.458 137.719 336.349 145.43 335.43 151.767C334.511 158.105 334.511 165.766 334.511 165.766L334.18 165.435C334.18 163.89 334.29 157.259 335.099 151.718C335.994 145.552 338.065 137.768 339.254 135.194L339.267 135.17Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15,
    d: "M421.911 135.697L421.371 131.909H431.68L432.624 133.809L434.304 136.383C433.482 135.93 432.146 135.697 432.146 135.697H421.911Z",
    fill: "url(#paint3_linear_2221_3109)"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M434.818 115.777C435.088 119.589 435.088 123.365 435.088 123.365L422.572 123.463V109.06L433.96 109.305C433.96 109.305 434.549 111.965 434.818 115.777Z",
    fill: "#222222"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M424.29 114H435.322L434.93 111.59L424.29 111.548V114Z",
    fill: "url(#paint4_linear_2221_3109)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M424.291 117.678H435.323L434.931 115.268L424.291 115.226V117.678Z",
    fill: "url(#paint5_linear_2221_3109)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M424.29 121.355H435.322L434.93 118.945L424.29 118.903V121.355Z",
    fill: "url(#paint6_linear_2221_3109)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15,
    d: "M432.147 135.697C432.147 135.697 433.495 135.93 434.304 136.383L434.353 136.469C434.353 136.469 434.66 138.394 434.549 142.831C434.451 146.594 434.439 154.035 434.439 156.205L434.304 156.94H421.519L421.911 135.697H432.147Z",
    fill: "url(#paint7_linear_2221_3109)"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M398.032 151.963H421.371V155.358H398.154L398.277 152.944C398.277 152.944 398.191 152.588 398.019 151.963H398.032Z",
    fill: "#21292B"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M421.519 106.596L417.057 106.51L418.014 87.9517L425.185 88.442L433.25 91.6413L434.17 103.397H434.856L435.04 106.376H434.354L434.39 108.214H434.035L433.961 109.318L432.76 107.368H421.519V106.596Z",
    fill: "#B1C8DA"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M392.1 153.165C392.1 153.165 392.075 153.091 392.051 152.957H398.29L398.167 155.359L398.033 157.982H392.982L392.112 153.165H392.1Z",
    fill: "#21292B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M434.439 156.265V156.805C434.439 156.805 436.057 153.802 436.327 152.87C436.596 151.951 437.246 150.713 438.374 150.872C438.41 150.872 438.447 150.896 438.472 150.896C438.177 151.718 436.437 156.56 435.432 157.773C434.328 159.085 431.472 158.999 428.42 159.085C425.356 159.171 422.634 159.085 422.634 159.085V156.927H434.304L434.439 156.253V156.265Z",
    fill: "#21292B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M413.515 85.0711L405.792 47.6839H405.78C405.768 47.6104 403.782 40.9052 396.881 40.8317L360.278 40.4517V89.8799C360.278 91.1702 360.901 92.3812 361.95 93.1323L380.774 106.609L385.236 131.934H414.336L414.483 108.006V106.609L413.515 88.4421V85.0711Z",
    fill: "#B1C8DA"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M363 88.2583H375.258V91.9357H363V88.2583Z",
    fill: "#141C1E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M419.299 43.16C419.177 42.829 419.067 42.449 418.968 42.0322C421.702 44.7535 425.894 45.7219 427.708 46.0284C428.285 47.8426 428.652 49.2522 428.652 49.2522L426.213 49.7548L422.903 47.3277C422.903 47.3277 420.157 45.44 419.287 43.1722L419.299 43.16Z",
    fill: "#303E42"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M424.939 39.2378C426.728 41.9958 428.665 49.2526 428.665 49.2526L426.226 49.7552L422.916 47.3281C422.916 47.3281 420.17 45.4403 419.3 43.1726C418.43 40.9049 418.295 35.9648 418.295 35.9648C418.295 35.9648 423.137 36.4919 424.926 39.25L424.939 39.2378Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M336.913 113.914L334.424 118.866V97.0591H337.317L336.913 113.914Z",
    fill: "url(#paint8_linear_2221_3109)"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M334.78 124.052H339.573L334.793 134.3L332.819 134.974L335.038 128.808L336.619 126.589H334.78V124.052Z",
    fill: "url(#paint9_linear_2221_3109)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M427.844 147.293V140.159C427.844 138.945 428.837 137.952 430.05 137.952H434.5C434.561 138.982 434.61 140.588 434.561 142.831C434.512 144.559 434.488 147.084 434.475 149.499H430.062C428.849 149.499 427.856 148.506 427.856 147.293H427.844Z",
    fill: "black"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M430.049 137.94H432.366C432.525 138.247 432.636 138.615 432.636 139.068V147.747C432.636 147.747 432.599 148.666 431.974 149.5H430.049C428.836 149.5 427.843 148.507 427.843 147.293V140.159C427.843 138.946 428.836 137.953 430.049 137.953V137.94Z",
    fill: "url(#paint10_linear_2221_3109)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M415.537 42.4741C416.554 42.6212 418.037 42.9032 419.3 43.1606C420.17 45.4283 422.916 47.3161 422.916 47.3161C422.916 47.3161 425.895 56.4606 427.783 64.9555C429.658 73.4503 431.497 85.9903 431.497 85.9903L433.054 88.5645C433.054 88.5645 433.789 89.251 433.789 89.9374C433.789 90.6239 433.237 91.6413 433.237 91.6413C433.237 91.6413 429.989 92.1439 427.844 91.102C425.699 90.06 423.1 87.8536 423.1 87.8536C423.1 87.8536 420.232 70.6187 419.165 65.458C418.099 60.2974 415.463 48.5174 415.144 47.3896C414.814 46.2619 413.379 42.2044 415.537 42.4986V42.4741Z",
    fill: "url(#paint11_linear_2221_3109)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M431.496 85.9902C431.496 85.9902 426.507 86.0882 425.71 83.2198C424.914 80.3514 422.339 66.7817 421.383 61.8417C420.427 56.8895 418.846 50.5398 418.503 49.2527C418.147 47.9411 418.172 47.1933 418.981 47.2791C419.79 47.3649 422.915 47.3282 422.915 47.3282C422.915 47.3282 425.894 56.4727 427.782 64.9675C429.657 73.4624 431.496 86.0024 431.496 86.0024V85.9902Z",
    fill: "#222222"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M366.916 45.3697C364.761 45.3402 363 47.4334 363 50.0129V81.4099C363 83.9894 364.761 86.23 366.904 86.4069L405.169 89.4729C407.312 89.6497 408.716 87.7187 408.273 85.1981L402.213 50.3225C401.782 47.8019 399.652 45.7235 397.509 45.694L366.916 45.355V45.3697Z",
    fill: "#21292B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M405.331 88.2581C405.944 88.2581 406.458 88.0062 406.776 87.5321C407.107 87.0431 407.205 86.3468 407.07 85.5616L401.044 50.5068C400.713 48.5807 399.06 46.9362 397.431 46.9213L367.006 46.5806C365.463 46.5806 364.226 48.077 364.226 49.9142V81.4723C364.226 83.354 365.536 85.043 367.079 85.1615L405.135 88.2432C405.196 88.2432 405.258 88.2432 405.319 88.2432L405.331 88.2581Z",
    fill: "#161C21"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M366.884 46.9731L397.333 47.2551C398.964 47.2673 400.619 48.628 400.95 50.2215L403.095 60.5551C394.968 58.8635 378.248 55.5293 364.102 53.9848V49.7312C364.102 48.2112 365.34 46.9731 366.884 46.9731Z",
    fill: "url(#paint12_linear_2221_3109)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-38-inside-4_2221_3109",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.049 137.94H432.366C432.525 138.247 432.636 138.615 432.636 139.068V147.747C432.636 147.747 432.599 148.666 431.974 149.5H430.049C428.836 149.5 427.843 148.507 427.843 147.293V140.159C427.843 138.946 428.836 137.953 430.049 137.953V137.94Z"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M430.049 137.94H432.366C432.525 138.247 432.636 138.615 432.636 139.068V147.747C432.636 147.747 432.599 148.666 431.974 149.5H430.049C428.836 149.5 427.843 148.507 427.843 147.293V140.159C427.843 138.946 428.836 137.953 430.049 137.953V137.94Z",
    fill: "url(#paint13_linear_2221_3109)",
    stroke: "#222222",
    strokeWidth: 2,
    mask: "url(#path-38-inside-4_2221_3109)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M403.549 89.1046C403.549 89.1046 402.813 88.982 402.715 88.271C402.617 87.5723 401.82 83.5762 401.82 83.5762H400.068C400.068 83.5762 400.068 90.5633 400.227 91.5807C400.386 92.5981 400.546 93.113 401.6 93.3091C402.654 93.5052 403.549 93.3091 403.549 93.3091V89.0923V89.1046Z",
    fill: "#21292B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M402.396 46.7888V45.0972H400.802C400.802 45.0972 399.871 45.6733 399.687 47.3894C399.503 49.1178 398.829 53.6165 398.829 53.6165H400.619C400.619 53.6165 401.256 48.6398 401.415 47.8062C401.575 46.9727 402.408 46.7888 402.408 46.7888H402.396Z",
    fill: "#21292B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M400.692 53.0527H397.566C396.353 53.0527 395.36 54.0456 395.36 55.2592V81.6876C395.36 82.9012 396.353 83.8941 397.566 83.8941H400.692C401.906 83.8941 402.898 82.9012 402.898 81.6876V55.2592C402.898 54.0456 401.906 53.0527 400.692 53.0527Z",
    fill: "url(#paint14_linear_2221_3109)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M402.2 53.0527H399.074C397.86 53.0527 396.867 54.0456 396.867 55.2592V81.6876C396.867 82.9012 397.86 83.8941 399.074 83.8941H402.2C403.413 83.8941 404.406 82.9012 404.406 81.6876V55.2592C404.406 54.0456 403.413 53.0527 402.2 53.0527Z",
    fill: "#222222"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 0L323.613 0V129.936L-0.000244141 129.936V0Z",
    fill: "#222222"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-44-inside-5_2221_3109",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.452 3.67676L319.937 3.67676V126.258L2.452 126.258V3.67676Z"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M2.452 3.67676L319.937 3.67676V126.258L2.452 126.258V3.67676Z",
    fill: "#222222",
    stroke: "url(#paint15_linear_2221_3109)",
    strokeWidth: 6,
    mask: "url(#path-44-inside-5_2221_3109)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M338.263 164.368C338.263 150.088 349.835 138.516 364.115 138.516C378.396 138.516 389.968 150.088 389.968 164.368C389.968 178.649 378.396 190.221 364.115 190.221C349.835 190.221 338.263 178.649 338.263 164.368Z",
    fill: "url(#paint16_linear_2221_3109)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M340.273 164.368C340.273 151.203 350.95 140.526 364.115 140.526C377.281 140.526 387.97 151.203 387.97 164.368C387.97 177.533 377.293 188.21 364.115 188.21C350.938 188.21 340.273 177.533 340.273 164.368Z",
    fill: "#222222"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M345.569 164.368C345.569 154.12 353.868 145.821 364.116 145.821C374.363 145.821 382.662 154.12 382.662 164.368C382.662 174.616 374.363 182.914 364.116 182.914C353.868 182.914 345.569 174.616 345.569 164.368Z",
    fill: "url(#paint17_linear_2221_3109)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M363.805 181.208C354.497 181.039 347.089 173.357 347.258 164.05C347.427 154.743 355.109 147.335 364.416 147.504C373.724 147.673 381.132 155.355 380.963 164.662C380.794 173.969 373.112 181.377 363.805 181.208Z",
    fill: "#222222"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M349.468 164.368C349.468 156.277 356.026 149.707 364.128 149.707C372.231 149.707 378.789 156.265 378.789 164.368C378.789 172.47 372.231 179.028 364.128 179.028C356.026 179.028 349.468 172.47 349.468 164.368Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M353.194 164.258C353.194 158.166 358.134 153.226 364.226 153.226C370.319 153.226 375.259 158.166 375.259 164.258C375.259 170.35 370.319 175.29 364.226 175.29C358.134 175.29 353.194 170.35 353.194 164.258Z",
    fill: "#222222"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M358.538 164.368C358.538 161.292 361.039 158.791 364.116 158.791C367.193 158.791 369.693 161.292 369.693 164.368C369.693 167.445 367.193 169.946 364.116 169.946C361.039 169.946 358.538 167.445 358.538 164.368Z",
    fill: "#D0E1EE"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M359.2 164.369C359.2 161.66 361.407 159.453 364.116 159.453C366.825 159.453 369.031 161.66 369.031 164.369C369.031 167.078 366.837 169.284 364.116 169.284C361.394 169.284 359.2 167.09 359.2 164.369Z",
    fill: "url(#paint18_linear_2221_3109)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2221_3109",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 353,
    y: 153,
    width: 23,
    height: 23
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M353.194 164.258C353.194 158.166 358.134 153.226 364.226 153.226C370.319 153.226 375.259 158.166 375.259 164.258C375.259 170.35 370.319 175.29 364.226 175.29C358.134 175.29 353.194 170.35 353.194 164.258Z",
    fill: "#222222"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2221_3109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.207 153.09C362.207 153.691 362.8 154.169 363.521 154.169C364.243 154.169 364.836 153.679 364.836 153.09C364.836 152.502 364.243 152 363.521 152C362.8 152 362.207 152.49 362.207 153.09Z",
    fill: "url(#paint19_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.207 175.216C362.207 175.817 362.8 176.295 363.521 176.295C364.243 176.295 364.836 175.804 364.836 175.216C364.836 174.628 364.243 174.137 363.521 174.137C362.8 174.137 362.207 174.628 362.207 175.216Z",
    fill: "url(#paint20_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.64 154.378C368.303 154.868 368.512 155.616 369.094 156.07C369.687 156.523 370.432 156.499 370.769 156.008C371.106 155.518 370.897 154.77 370.315 154.317C369.722 153.863 368.978 153.888 368.64 154.378Z",
    fill: "url(#paint21_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.284 172.288C355.947 172.778 356.157 173.526 356.75 173.979C357.331 174.433 358.088 174.396 358.425 173.918C358.751 173.428 358.553 172.68 357.96 172.226C357.366 171.773 356.622 171.797 356.296 172.288H356.284Z",
    fill: "url(#paint22_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.922 166.242C373.375 166.058 372.759 166.499 372.537 167.223C372.316 167.946 372.572 168.694 373.108 168.877C373.654 169.061 374.271 168.62 374.492 167.897C374.713 167.174 374.457 166.426 373.922 166.242Z",
    fill: "url(#paint23_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.947 159.402C353.4 159.218 352.784 159.659 352.563 160.383C352.342 161.106 352.598 161.854 353.133 162.038C353.68 162.221 354.296 161.78 354.517 161.057C354.738 160.334 354.482 159.586 353.947 159.402Z",
    fill: "url(#paint24_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.794 159.71C373.259 159.894 373.003 160.63 373.224 161.365C373.445 162.088 374.073 162.53 374.608 162.346C375.143 162.162 375.399 161.414 375.178 160.691C374.957 159.968 374.341 159.526 373.794 159.71Z",
    fill: "url(#paint25_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.82 166.551C353.274 166.734 353.029 167.482 353.25 168.205C353.471 168.941 354.1 169.382 354.635 169.186C355.17 169.002 355.426 168.267 355.205 167.531C354.984 166.808 354.355 166.367 353.82 166.551Z",
    fill: "url(#paint26_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.458 172.582C371.121 172.104 370.376 172.067 369.783 172.521C369.19 172.974 368.992 173.734 369.329 174.212C369.667 174.691 370.411 174.727 370.993 174.274C371.586 173.82 371.784 173.06 371.458 172.582Z",
    fill: "url(#paint27_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.103 154.672C358.765 154.194 358.021 154.157 357.439 154.611C356.846 155.064 356.648 155.824 356.974 156.302C357.311 156.78 358.056 156.817 358.649 156.364C359.242 155.91 359.44 155.15 359.114 154.672H359.103Z",
    fill: "url(#paint28_linear_2221_3109)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 19.6129,
    height: 2.45162,
    transform: "matrix(-0.996796 -0.0799898 -0.0799898 0.996796 398.615 28.9819)",
    fill: "#222222"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M197.956 162.26C197.956 162.26 197.956 162.137 197.956 162.088C197.956 147.342 185.746 135.39 170.693 135.39C155.641 135.39 143.431 147.342 143.431 162.088C143.431 162.149 143.431 162.211 143.431 162.26H139.423C139.423 162.26 139.423 162.137 139.423 162.088C139.423 145.172 153.422 131.467 170.693 131.467C187.965 131.467 201.964 145.172 201.964 162.088C201.964 162.149 201.964 162.211 201.964 162.26H197.956Z",
    fill: "#222222"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M170.707 131.456C187.979 131.456 201.978 145.16 201.978 162.076C201.978 162.138 201.978 162.199 201.978 162.248H201.316C201.316 162.248 201.316 162.125 201.316 162.076C201.316 145.516 187.611 132.105 170.707 132.105C153.803 132.105 140.099 145.528 140.099 162.076C140.099 162.138 140.099 162.199 140.099 162.248H139.437C139.437 162.248 139.437 162.125 139.437 162.076C139.437 145.16 153.435 131.456 170.707 131.456Z",
    fill: "url(#paint29_linear_2221_3109)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M144.585 164.368C144.585 150.088 156.157 138.516 170.438 138.516C184.718 138.516 196.29 150.088 196.29 164.368C196.29 178.649 184.718 190.221 170.438 190.221C156.157 190.221 144.585 178.649 144.585 164.368Z",
    fill: "url(#paint30_linear_2221_3109)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M146.596 164.368C146.596 151.203 157.273 140.526 170.438 140.526C183.603 140.526 194.292 151.203 194.292 164.368C194.292 177.534 183.615 188.21 170.438 188.21C157.26 188.21 146.596 177.534 146.596 164.368Z",
    fill: "#222222"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M151.891 164.368C151.891 154.12 160.19 145.821 170.438 145.821C180.686 145.821 188.984 154.12 188.984 164.368C188.984 174.616 180.686 182.914 170.438 182.914C160.19 182.914 151.891 174.616 151.891 164.368Z",
    fill: "url(#paint31_linear_2221_3109)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M170.126 181.208C160.819 181.039 153.411 173.357 153.58 164.05C153.749 154.743 161.431 147.335 170.738 147.504C180.045 147.673 187.453 155.355 187.284 164.662C187.115 173.969 179.433 181.377 170.126 181.208Z",
    fill: "#222222"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M155.788 164.368C155.788 156.278 162.346 149.708 170.449 149.708C178.551 149.708 185.109 156.266 185.109 164.368C185.109 172.471 178.551 179.029 170.449 179.029C162.346 179.029 155.788 172.471 155.788 164.368Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M159.515 164.258C159.515 158.166 164.455 153.226 170.547 153.226C176.639 153.226 181.579 158.166 181.579 164.258C181.579 170.35 176.639 175.29 170.547 175.29C164.455 175.29 159.515 170.35 159.515 164.258Z",
    fill: "#222222"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M164.86 164.368C164.86 161.292 167.36 158.791 170.437 158.791C173.514 158.791 176.015 161.292 176.015 164.368C176.015 167.445 173.514 169.946 170.437 169.946C167.36 169.946 164.86 167.445 164.86 164.368Z",
    fill: "#D0E1EE"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M165.522 164.369C165.522 161.66 167.728 159.453 170.437 159.453C173.146 159.453 175.353 161.66 175.353 164.369C175.353 167.078 173.158 169.284 170.437 169.284C167.716 169.284 165.522 167.09 165.522 164.369Z",
    fill: "url(#paint32_linear_2221_3109)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2221_3109",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 159,
    y: 153,
    width: 23,
    height: 23
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M159.515 164.258C159.515 158.166 164.455 153.226 170.547 153.226C176.639 153.226 181.579 158.166 181.579 164.258C181.579 170.35 176.639 175.29 170.547 175.29C164.455 175.29 159.515 170.35 159.515 164.258Z",
    fill: "#222222"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2221_3109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.528 153.091C168.528 153.692 169.121 154.17 169.843 154.17C170.564 154.17 171.157 153.679 171.157 153.091C171.157 152.503 170.564 152 169.843 152C169.121 152 168.528 152.49 168.528 153.091Z",
    fill: "url(#paint33_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.528 175.216C168.528 175.817 169.121 176.295 169.843 176.295C170.564 176.295 171.157 175.805 171.157 175.216C171.157 174.628 170.564 174.138 169.843 174.138C169.121 174.138 168.528 174.628 168.528 175.216Z",
    fill: "url(#paint34_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.96 154.379C174.623 154.869 174.833 155.617 175.414 156.071C176.007 156.524 176.752 156.5 177.089 156.009C177.427 155.519 177.217 154.771 176.636 154.318C176.042 153.864 175.298 153.889 174.96 154.379Z",
    fill: "url(#paint35_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.605 172.289C162.267 172.779 162.477 173.527 163.07 173.98C163.652 174.434 164.408 174.397 164.745 173.919C165.071 173.429 164.873 172.681 164.28 172.227C163.687 171.774 162.942 171.798 162.616 172.289H162.605Z",
    fill: "url(#paint36_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.242 166.243C179.695 166.059 179.079 166.5 178.858 167.224C178.637 167.947 178.893 168.695 179.428 168.878C179.975 169.062 180.591 168.621 180.812 167.898C181.033 167.175 180.777 166.427 180.242 166.243Z",
    fill: "url(#paint37_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.268 159.403C159.722 159.219 159.105 159.66 158.884 160.384C158.663 161.107 158.919 161.855 159.454 162.039C160.001 162.222 160.617 161.781 160.838 161.058C161.06 160.335 160.804 159.587 160.268 159.403Z",
    fill: "url(#paint38_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.116 159.71C179.581 159.894 179.325 160.63 179.546 161.365C179.767 162.088 180.395 162.53 180.931 162.346C181.466 162.162 181.722 161.414 181.501 160.691C181.28 159.968 180.663 159.526 180.116 159.71Z",
    fill: "url(#paint39_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.143 166.55C159.596 166.734 159.352 167.482 159.573 168.205C159.794 168.94 160.422 169.382 160.957 169.186C161.492 169.002 161.748 168.266 161.527 167.531C161.306 166.807 160.678 166.366 160.143 166.55Z",
    fill: "url(#paint40_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.778 172.582C177.441 172.104 176.697 172.067 176.103 172.521C175.51 172.974 175.312 173.734 175.65 174.212C175.987 174.691 176.732 174.727 177.313 174.274C177.906 173.82 178.104 173.06 177.778 172.582Z",
    fill: "url(#paint41_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.423 154.672C165.086 154.194 164.341 154.158 163.76 154.611C163.166 155.065 162.969 155.825 163.294 156.303C163.632 156.781 164.376 156.818 164.969 156.364C165.563 155.911 165.76 155.151 165.435 154.672H165.423Z",
    fill: "url(#paint42_linear_2221_3109)"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M129.751 162.26C129.751 162.26 129.751 162.137 129.751 162.088C129.751 147.342 117.542 135.39 102.489 135.39C87.4364 135.39 75.2274 147.342 75.2274 162.088C75.2274 162.149 75.2274 162.211 75.2274 162.26H71.219C71.219 162.26 71.219 162.137 71.219 162.088C71.219 145.172 85.2177 131.467 102.489 131.467C119.761 131.467 133.76 145.172 133.76 162.088C133.76 162.149 133.76 162.211 133.76 162.26H129.751Z",
    fill: "#222222"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M102.502 131.456C119.774 131.456 133.772 145.161 133.772 162.077C133.772 162.138 133.772 162.199 133.772 162.248H133.111C133.111 162.248 133.111 162.126 133.111 162.077C133.111 145.516 119.406 132.106 102.502 132.106C85.5982 132.106 71.8937 145.528 71.8937 162.077C71.8937 162.138 71.8937 162.199 71.8937 162.248H71.2317C71.2317 162.248 71.2317 162.126 71.2317 162.077C71.2317 145.161 85.2304 131.456 102.502 131.456Z",
    fill: "url(#paint43_linear_2221_3109)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3804 164.369C76.3804 150.088 87.952 138.517 102.233 138.517C116.513 138.517 128.085 150.088 128.085 164.369C128.085 178.65 116.513 190.221 102.233 190.221C87.952 190.221 76.3804 178.65 76.3804 164.369Z",
    fill: "url(#paint44_linear_2221_3109)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3907 164.369C78.3907 151.204 89.0675 140.527 102.233 140.527C115.398 140.527 126.087 151.204 126.087 164.369C126.087 177.534 115.41 188.211 102.233 188.211C89.0552 188.211 78.3907 177.534 78.3907 164.369Z",
    fill: "#222222"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6853 164.369C83.6853 154.121 91.9841 145.823 102.232 145.823C112.48 145.823 120.778 154.121 120.778 164.369C120.778 174.617 112.48 182.916 102.232 182.916C91.9841 182.916 83.6853 174.617 83.6853 164.369Z",
    fill: "url(#paint45_linear_2221_3109)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M101.922 181.21C92.6146 181.041 85.2067 173.359 85.3756 164.052C85.5446 154.745 93.2265 147.337 102.534 147.506C111.841 147.675 119.249 155.356 119.08 164.664C118.911 173.971 111.229 181.379 101.922 181.21Z",
    fill: "#222222"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5839 164.369C87.5839 156.279 94.142 149.708 102.245 149.708C110.347 149.708 116.905 156.267 116.905 164.369C116.905 172.472 110.347 179.03 102.245 179.03C94.142 179.03 87.5839 172.472 87.5839 164.369Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3095 164.258C91.3095 158.166 96.2496 153.226 102.342 153.226C108.434 153.226 113.374 158.166 113.374 164.258C113.374 170.351 108.434 175.291 102.342 175.291C96.2496 175.291 91.3095 170.351 91.3095 164.258Z",
    fill: "#222222"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6547 164.369C96.6547 161.293 99.1553 158.792 102.232 158.792C105.309 158.792 107.81 161.293 107.81 164.369C107.81 167.446 105.309 169.947 102.232 169.947C99.1553 169.947 96.6547 167.446 96.6547 164.369Z",
    fill: "#D0E1EE"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3165 164.369C97.3165 161.66 99.5229 159.454 102.232 159.454C104.941 159.454 107.147 161.66 107.147 164.369C107.147 167.078 104.953 169.285 102.232 169.285C99.5107 169.285 97.3165 167.09 97.3165 164.369Z",
    fill: "url(#paint46_linear_2221_3109)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2221_3109",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 153,
    width: 23,
    height: 23
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3095 164.258C91.3095 158.166 96.2496 153.226 102.342 153.226C108.434 153.226 113.374 158.166 113.374 164.258C113.374 170.351 108.434 175.291 102.342 175.291C96.2496 175.291 91.3095 170.351 91.3095 164.258Z",
    fill: "#222222"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2221_3109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.321 153.092C100.321 153.693 100.914 154.171 101.636 154.171C102.357 154.171 102.95 153.68 102.95 153.092C102.95 152.504 102.357 152.001 101.636 152.001C100.914 152.001 100.321 152.491 100.321 153.092Z",
    fill: "url(#paint47_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.321 175.217C100.321 175.818 100.914 176.296 101.636 176.296C102.357 176.296 102.95 175.805 102.95 175.217C102.95 174.629 102.357 174.138 101.636 174.138C100.914 174.138 100.321 174.629 100.321 175.217Z",
    fill: "url(#paint48_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.755 154.38C106.418 154.87 106.627 155.618 107.209 156.072C107.802 156.525 108.547 156.501 108.884 156.01C109.222 155.52 109.012 154.772 108.431 154.319C107.837 153.865 107.093 153.89 106.755 154.38Z",
    fill: "url(#paint49_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3997 172.29C94.0624 172.78 94.2718 173.528 94.865 173.981C95.4467 174.435 96.2028 174.398 96.5402 173.92C96.8659 173.43 96.6682 172.682 96.0749 172.228C95.4816 171.775 94.7371 171.799 94.4114 172.29H94.3997Z",
    fill: "url(#paint50_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.036 166.244C111.489 166.06 110.873 166.502 110.652 167.225C110.431 167.948 110.687 168.696 111.222 168.88C111.769 169.064 112.385 168.622 112.606 167.899C112.827 167.176 112.571 166.428 112.036 166.244Z",
    fill: "url(#paint51_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0615 159.404C91.5147 159.22 90.8982 159.661 90.6771 160.385C90.4561 161.108 90.712 161.856 91.2471 162.04C91.7939 162.223 92.4104 161.782 92.6315 161.059C92.8525 160.336 92.5966 159.588 92.0615 159.404Z",
    fill: "url(#paint52_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.911 159.711C111.376 159.895 111.12 160.63 111.341 161.366C111.562 162.089 112.19 162.53 112.726 162.346C113.261 162.162 113.517 161.415 113.296 160.691C113.074 159.968 112.458 159.527 111.911 159.711Z",
    fill: "url(#paint53_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9376 166.551C91.3908 166.735 91.1465 167.483 91.3676 168.206C91.5886 168.941 92.2168 169.383 92.7519 169.187C93.287 169.003 93.5429 168.267 93.3219 167.532C93.1009 166.808 92.4727 166.367 91.9376 166.551Z",
    fill: "url(#paint54_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.573 172.582C109.236 172.104 108.492 172.067 107.898 172.521C107.305 172.974 107.107 173.734 107.445 174.212C107.782 174.691 108.526 174.727 109.108 174.274C109.701 173.82 109.899 173.06 109.573 172.582Z",
    fill: "url(#paint55_linear_2221_3109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2171 154.672C96.8797 154.194 96.1352 154.158 95.5535 154.611C94.9602 155.065 94.7625 155.825 95.0882 156.303C95.4256 156.781 96.1701 156.818 96.7634 156.364C97.3566 155.911 97.5544 155.151 97.2287 154.672H97.2171Z",
    fill: "url(#paint56_linear_2221_3109)"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9767 47.207V80.1826H67.5114V65.9848H54.0464V80.1826H46.5811V47.207H54.0464V59.6645H67.5114V47.207H74.9767Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M107.172 67.9092C107.172 75.5119 101.447 80.7788 93.4782 80.7788C85.4633 80.7788 79.7842 75.5119 79.7842 67.9092C79.7842 60.3523 85.4633 55.0396 93.4782 55.0396C101.447 55.0396 107.172 60.3523 107.172 67.9092ZM99.7985 67.9092C99.7985 62.6881 97.5544 60.8103 93.4782 60.8103C89.3563 60.8103 87.1579 62.6881 87.1579 67.9092C87.1579 73.1761 89.3563 75.0081 93.4782 75.0081C97.5544 75.0081 99.7985 73.1761 99.7985 67.9092Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M122.699 74.4131V80.1839H121.554C115.142 80.1839 111.433 76.8405 111.433 71.1156V43.2695H118.532V70.8866C118.532 73.6345 119.493 74.4131 121.921 74.4131H122.699Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M181.735 55.6354V77.1612C181.735 85.4508 177.751 90.0766 167.95 90.0766C160.622 90.0766 157.324 86.6416 155.584 81.7411H162.408C163.141 83.7563 164.973 84.4433 168.041 84.4433C172.759 84.4433 174.637 83.2983 174.637 77.9856V75.9704C173.354 78.0314 171.476 79.3595 167.263 79.3595C160.988 79.3595 155.126 74.3216 155.126 67.3601C155.126 60.2154 160.576 55.04 167.263 55.04C171.293 55.04 173.492 56.9178 174.637 58.8414V55.6354H181.735ZM174.637 65.4365C173.583 62.2306 172.392 60.765 168.133 60.765C164.652 60.765 162.5 62.7343 162.5 67.3601C162.5 72.5354 164.606 74.0926 168.179 74.0926C172.759 74.0926 173.904 72.5354 174.637 69.2837V65.4365Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M204.085 55.5438V62.1389C203.352 61.8184 202.253 61.6352 200.879 61.6352C196.849 61.6352 194.147 63.5587 194.147 68.7341V80.1839H187.048V55.6354H194.147V59.2078C195.383 56.643 197.994 55.04 201.291 55.04C202.345 55.04 203.398 55.2232 204.085 55.5438Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M232.023 74.4132V80.1839H230.969C226.939 80.1839 225.474 79.1305 224.42 77.207C223.321 79.3137 219.932 80.7793 215.947 80.7793C210.909 80.7793 206.009 78.2604 206.009 72.7644C206.009 67.3601 211.642 65.0243 216.909 65.0243C218.814 64.9904 220.699 65.4145 222.405 66.2609V64.4289C222.405 61.5894 221.489 60.4444 218.054 60.4444C215.672 60.4444 214.436 60.8108 213.841 62.5969H206.925C208.665 57.1468 212.741 55.04 218.008 55.04C225.428 55.04 229.504 58.5666 229.504 64.7037V72.3522C229.504 73.9552 230.237 74.4132 231.427 74.4132H232.023ZM222.405 70.8408C221.168 69.9707 220.023 69.4669 217.138 69.4669C214.207 69.4669 213.291 70.337 213.291 72.4896C213.291 74.5048 214.207 75.375 216.863 75.375C219.611 75.375 221.077 75.0086 222.405 73.2224V70.8408Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M252.45 43.499V49.2239C251.186 48.8566 249.875 48.6715 248.558 48.6743C246.405 48.6743 245.123 49.6819 245.123 52.2924V55.6358H251.992V61.4065H245.123V80.1843H238.024V61.4065H233.169V55.6358H238.024V52.2466C238.024 46.8423 242.237 42.9036 247.413 42.9036C249.11 42.8954 250.802 43.0953 252.45 43.499Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M151.781 67.1225C151.781 74.4652 146.159 79.5521 138.335 79.5521C130.464 79.5521 124.887 74.4652 124.887 67.1225C124.887 59.824 130.464 54.6929 138.335 54.6929C146.161 54.6951 151.781 59.824 151.781 67.1225Z",
    fill: "#222222",
    stroke: "url(#paint57_radial_2221_3109)",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M140.602 75.037C144.289 75.0369 147.887 73.9228 150.909 71.8455C149.042 76.5564 144.337 79.5532 138.335 79.5532C135.427 79.5532 132.832 78.8565 130.716 77.6114C131.35 76.8107 132.162 76.1627 133.089 75.7166C134.016 75.2705 135.034 75.0381 136.066 75.037H140.602ZM140.602 70.576H136.066C134.395 70.5761 132.745 70.9407 131.235 71.6437C129.725 72.3467 128.393 73.3704 127.334 74.6411C127.796 75.2412 128.317 75.7953 128.89 76.2954C129.734 75.2125 130.821 74.335 132.065 73.7307C133.309 73.1263 134.678 72.8112 136.066 72.8098H140.602C144.769 72.8103 148.768 71.1928 151.729 68.3091C151.763 67.9198 151.781 67.5261 151.781 67.1258C151.782 66.4246 151.727 65.7244 151.619 65.0314C150.361 66.748 148.706 68.1459 146.79 69.1099C144.875 70.0739 142.754 70.5764 140.602 70.576ZM140.602 59.4248C141.203 59.4242 141.779 59.1891 142.204 58.7712C142.629 58.3532 142.868 57.7865 142.869 57.1954V55.3266C141.396 54.9001 139.868 54.687 138.333 54.694C132.582 54.694 128.06 57.4343 126.038 61.7537C129.152 60.2257 132.584 59.4293 136.064 59.427L140.602 59.4248ZM140.602 63.8857C142.325 63.8831 143.982 63.2383 145.241 62.0813C146.5 60.9244 147.266 59.3413 147.385 57.651C146.689 57.0952 145.935 56.614 145.136 56.2156V57.1954C145.134 58.378 144.655 59.5116 143.805 60.3478C142.955 61.1841 141.802 61.6546 140.6 61.6564H136.066C132.17 61.6547 128.356 62.7591 125.082 64.8367C124.951 65.5922 124.886 66.3572 124.887 67.1236C124.887 67.316 124.887 67.504 124.9 67.6942C128.081 65.2268 132.015 63.8858 136.066 63.8879L140.602 63.8857ZM136.066 68.3467H140.602C142.723 68.3451 144.802 67.7578 146.6 66.6516C148.399 65.5454 149.846 63.9649 150.776 62.0898C150.396 61.21 149.907 60.3801 149.319 59.6194C148.781 61.4867 147.639 63.1308 146.066 64.3029C144.494 65.475 142.575 66.1111 140.602 66.1151H136.066C132.056 66.1175 128.197 67.6198 125.271 70.3173C125.466 71.1211 125.744 71.903 126.101 72.6506C127.37 71.2949 128.91 70.2126 130.625 69.4718C132.34 68.731 134.193 68.3479 136.066 68.3467Z",
    fill: "url(#paint58_radial_2221_3109)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M151.781 67.1225C151.781 74.4652 146.159 79.5521 138.335 79.5521C130.464 79.5521 124.887 74.4652 124.887 67.1225C124.887 59.824 130.464 54.6929 138.335 54.6929C146.161 54.6951 151.781 59.824 151.781 67.1225Z",
    stroke: "url(#paint59_radial_2221_3109)",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M265.523 65.1692C270.231 66.0901 275.808 67.5174 275.808 72.9967C275.808 78.8442 270.048 80.9162 264.243 80.9162C257.433 80.9162 253.73 78.2457 252.45 72.7665H259.17C259.627 74.5161 260.404 75.483 264.015 75.483C267.123 75.483 268.54 74.9766 268.54 73.4571C268.54 71.7074 267.854 71.3851 263.923 70.6024C259.444 69.7276 253.319 68.2081 253.319 62.5908C253.319 57.3878 258.438 55.0396 264.38 55.0396C270.506 55.0396 274.437 57.7101 275.579 62.6828H268.86C268.22 61.1173 267.489 60.4727 264.609 60.4727C261.546 60.4727 260.495 61.1173 260.495 62.5447C260.495 63.88 261.501 64.3865 265.523 65.1692Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2221_3109",
    x1: 62.2088,
    y1: 158.635,
    x2: 57.0175,
    y2: 158.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2221_3109",
    x1: 290.325,
    y1: 170.941,
    x2: 240.155,
    y2: 114.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2221_3109",
    x1: 391.99,
    y1: 158.13,
    x2: 335.389,
    y2: 121.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2221_3109",
    x1: 424.902,
    y1: 134.152,
    x2: 433.09,
    y2: 134.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2221_3109",
    x1: 434.593,
    y1: 114.264,
    x2: 430.972,
    y2: 108.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2221_3109",
    x1: 434.594,
    y1: 117.941,
    x2: 430.973,
    y2: 111.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2221_3109",
    x1: 434.593,
    y1: 121.619,
    x2: 430.972,
    y2: 115.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2221_3109",
    x1: 425.711,
    y1: 146.325,
    x2: 435.53,
    y2: 146.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2221_3109",
    x1: 337.126,
    y1: 121.211,
    x2: 333.449,
    y2: 121.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2221_3109",
    x1: 339.127,
    y1: 136.148,
    x2: 330.964,
    y2: 134.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2221_3109",
    x1: 430.233,
    y1: 137.891,
    x2: 430.233,
    y2: 151.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#878787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2221_3109",
    x1: 432.505,
    y1: 97.0616,
    x2: 408.295,
    y2: 93.4631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2221_3109",
    x1: 400.516,
    y1: 62.0153,
    x2: 377.652,
    y2: 37.2498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2221_3109",
    x1: 432.319,
    y1: 150.743,
    x2: 426.357,
    y2: 149.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2221_3109",
    x1: 402.4,
    y1: 87.2099,
    x2: 392.874,
    y2: 86.3315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2221_3109",
    x1: 298.944,
    y1: 139.437,
    x2: 91.9826,
    y2: -62.7959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2221_3109",
    x1: 386.549,
    y1: 195.78,
    x2: 328.871,
    y2: 174.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2221_3109",
    x1: 380.209,
    y1: 186.902,
    x2: 338.831,
    y2: 171.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2221_3109",
    x1: 368.381,
    y1: 170.341,
    x2: 357.415,
    y2: 166.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2221_3109",
    x1: 364.662,
    y1: 154.402,
    x2: 361.891,
    y2: 153.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2221_3109",
    x1: 364.662,
    y1: 176.527,
    x2: 361.896,
    y2: 175.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2221_3109",
    x1: 370.769,
    y1: 156.652,
    x2: 368.048,
    y2: 155.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2221_3109",
    x1: 358.419,
    y1: 174.557,
    x2: 355.694,
    y2: 173.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2221_3109",
    x1: 374.432,
    y1: 169.211,
    x2: 371.952,
    y2: 168.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2221_3109",
    x1: 354.457,
    y1: 162.372,
    x2: 351.977,
    y2: 161.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2221_3109",
    x1: 375.118,
    y1: 162.68,
    x2: 372.638,
    y2: 161.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2221_3109",
    x1: 355.144,
    y1: 169.525,
    x2: 352.662,
    y2: 168.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2221_3109",
    x1: 371.452,
    y1: 174.851,
    x2: 368.737,
    y2: 173.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2221_3109",
    x1: 359.108,
    y1: 156.94,
    x2: 356.39,
    y2: 155.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2221_3109",
    x1: 197.842,
    y1: 165.558,
    x2: 147.63,
    y2: 127.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2221_3109",
    x1: 192.871,
    y1: 195.78,
    x2: 135.193,
    y2: 174.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2221_3109",
    x1: 186.532,
    y1: 186.902,
    x2: 145.154,
    y2: 171.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2221_3109",
    x1: 174.703,
    y1: 170.341,
    x2: 163.736,
    y2: 166.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2221_3109",
    x1: 170.983,
    y1: 154.403,
    x2: 168.212,
    y2: 153.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2221_3109",
    x1: 170.983,
    y1: 176.527,
    x2: 168.218,
    y2: 175.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2221_3109",
    x1: 177.089,
    y1: 156.653,
    x2: 174.368,
    y2: 155.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2221_3109",
    x1: 164.739,
    y1: 174.558,
    x2: 162.015,
    y2: 173.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2221_3109",
    x1: 180.752,
    y1: 169.212,
    x2: 178.272,
    y2: 168.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2221_3109",
    x1: 160.778,
    y1: 162.373,
    x2: 158.298,
    y2: 161.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2221_3109",
    x1: 181.44,
    y1: 162.68,
    x2: 178.961,
    y2: 161.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2221_3109",
    x1: 161.467,
    y1: 169.525,
    x2: 158.985,
    y2: 168.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2221_3109",
    x1: 177.773,
    y1: 174.851,
    x2: 175.057,
    y2: 173.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2221_3109",
    x1: 165.429,
    y1: 156.941,
    x2: 162.71,
    y2: 155.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2221_3109",
    x1: 129.637,
    y1: 165.559,
    x2: 79.4245,
    y2: 127.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2221_3109",
    x1: 124.666,
    y1: 195.78,
    x2: 66.9884,
    y2: 174.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2221_3109",
    x1: 118.326,
    y1: 186.904,
    x2: 76.9475,
    y2: 171.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2221_3109",
    x1: 106.497,
    y1: 170.342,
    x2: 95.5307,
    y2: 166.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2221_3109",
    x1: 102.776,
    y1: 154.404,
    x2: 100.005,
    y2: 153.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2221_3109",
    x1: 102.776,
    y1: 176.528,
    x2: 100.011,
    y2: 175.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2221_3109",
    x1: 108.884,
    y1: 156.654,
    x2: 106.163,
    y2: 155.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2221_3109",
    x1: 96.5338,
    y1: 174.559,
    x2: 93.8096,
    y2: 173.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2221_3109",
    x1: 112.546,
    y1: 169.214,
    x2: 110.066,
    y2: 168.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2221_3109",
    x1: 92.5712,
    y1: 162.374,
    x2: 90.0915,
    y2: 161.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2221_3109",
    x1: 113.235,
    y1: 162.68,
    x2: 110.756,
    y2: 161.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2221_3109",
    x1: 93.2615,
    y1: 169.526,
    x2: 90.7795,
    y2: 168.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2221_3109",
    x1: 109.568,
    y1: 174.851,
    x2: 106.852,
    y2: 173.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2221_3109",
    x1: 97.2226,
    y1: 156.941,
    x2: 94.5039,
    y2: 155.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_2221_3109",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(147.672 60.5272) rotate(-30.1396) scale(56.5825 29.1009)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_2221_3109",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(147.672 60.5282) rotate(-30.1397) scale(56.5826 29.1011)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_2221_3109",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(147.672 60.5272) rotate(-30.1396) scale(56.5825 29.1009)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckRight);
export default __webpack_public_path__ + "static/media/truck-right.a60c20939e93cee1496cbda8af01a0b1.svg";
export { ForwardRef as ReactComponent };